module.exports = __webpack_public_path__ + "static/media/image.e8f31fca.jpg";